/** Плейсхолдер карточки объявления на время загрузки списка */
export function AdSkeleton() {
  return (
    <div className="skeleton-card" aria-hidden="true">
      <div className="skeleton-card__photo" />
      <div className="skeleton-card__info">
        <div className="skeleton-card__line skeleton-card__line--w40" />
        <div className="skeleton-card__line skeleton-card__line--w80" />
        <div className="skeleton-card__line skeleton-card__line--w60" />
      </div>
    </div>
  );
}

export function AdSkeletonList({ count = 3 }: { count?: number }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: count }, (_, i) => (
        <AdSkeleton key={i} />
      ))}
    </div>
  );
}
